import { DAO, ERROR_MESSAGE_REQUIRED } from '../../config'
import { completeOnboarding } from '../../services/functions'

export const selectErrorHandling = placeholder => ({
  required: ERROR_MESSAGE_REQUIRED,
  pattern: {
    value: placeholder,
    message: ERROR_MESSAGE_REQUIRED
  }
})

export const callCompleteOnboarding = user => async vals => {
  const { uid } = user
  // Ensure a valid user and oboarding hasn't been already completed
  // !user?.appDate
  if (uid) {
    const res = await completeOnboarding({ uid, daoId: DAO })
    console.log('Completed onboarding:', res)
  }
}
